import { createGlobalStyle, css } from "styled-components";

import { reset, themeInputs, typography, fontsStyles } from "../../common/index";

import { colors } from "./palette";

const commonStyles = css`
  ${reset}
  ${fontsStyles}
  ${themeInputs}

  #root {
    height: 100%;
    ${typography.body1};

    /* width */
    div::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    /* Track */
    div::-webkit-scrollbar-track {
      background: transparent;
    }

    /* Handle */
    div::-webkit-scrollbar-thumb {
      background: ${colors.bg.divider};
      border-radius: 4px;
    }
  }
`;

export default createGlobalStyle`
  ${commonStyles}

  body * {
    color: ${colors.fg.primary};
  }
`;
